import { toast } from "@kyan/ui";

export const showComboWarningToast = () =>
  toast.warning({
    title: "Combo Strategy not available",
    description:
      "Due to market conditions or insufficient strikes, this strategy cannot be applied. Please try again later.",
  });

// Returns the index of the strike closest to the given index price (ATM)
export const findClosestATMStrikeIndex = (
  strikes: number[],
  indexPrice: number,
): number => {
  if (!strikes.length) return 0;

  return strikes.reduce((closestIndex, strike, index) => {
    if (
      Math.abs(strike - indexPrice) <
      Math.abs(strikes[closestIndex] - indexPrice)
    ) {
      return index;
    }

    return closestIndex;
  }, 0);
};
